/**
 * The soft sound a kiosk plays with a result (approved caption: "Soft sound").
 * Best effort: browsers block audio until a person has touched the page once,
 * and an unsupported browser is silent.
 */
let context: AudioContext | null = null;

function audio(): AudioContext | null {
  try {
    const Ctor =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctor) return null;
    context ??= new Ctor();
    if (context.state === "suspended") void context.resume().catch(() => undefined);
    return context;
  } catch {
    return null;
  }
}

/** Call from a tap so later results may play sound. */
export function unlockKioskSound(): void {
  audio();
}

function tone(ctx: AudioContext, frequency: number, start: number, duration: number) {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = "sine";
  oscillator.frequency.value = frequency;
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(0.12, start + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
  oscillator.connect(gain).connect(ctx.destination);
  oscillator.start(start);
  oscillator.stop(start + duration + 0.05);
}

export function playKioskChime(outcome: "green" | "red"): void {
  const ctx = audio();
  if (!ctx || ctx.state !== "running") return;
  try {
    const now = ctx.currentTime;
    if (outcome === "green") {
      tone(ctx, 880, now, 0.18);
      tone(ctx, 1318.5, now + 0.12, 0.28);
    } else {
      tone(ctx, 330, now, 0.22);
      tone(ctx, 247, now + 0.18, 0.34);
    }
  } catch {
    // Sound is a nicety; never let it break a scan result.
  }
}
